import React from 'react';
import { LambdaOperation } from '@api/lambdaOperationsApi';
import { getLambdaOperationTitle } from '../lambdaOperations.utils';

type Props = {
    operation: LambdaOperation;
    selected: boolean;
    onSelect: (operation: LambdaOperation) => void;
};

const LambdaOperationCard = ({ operation, selected, onSelect }: Props) => {
    const title = getLambdaOperationTitle(operation);
    const description = operation.description ? String(operation.description) : '';

    return (
        <button
            type="button"
            className={`lambda-operation-card ${selected ? 'selected' : ''}`}
            onClick={() => onSelect(operation)}
            aria-pressed={selected}
            data-testid="lambdaOperationCard"
        >
            <div className="lambda-operation-card__icon">
                {operation.icon ? String(operation.icon) : title[0]}
            </div>
            <div className="lambda-operation-card__content">
                <div className="lambda-operation-card__title-line">
                    <p className="lambda-operation-card__title">{title}</p>
                    {selected ? <span className="lambda-operation-card__selected">Selected</span> : null}
                </div>
                {description ? (
                    <p className="lambda-operation-card__description">{description}</p>
                ) : null}
            </div>
        </button>
    );
};

export default LambdaOperationCard;
